import React from "react";
import { Box, TextField, Radio, FormControlLabel, FormControl, FormLabel, RadioGroup, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import "./../NcdForm.css";

dayjs.extend(customParseFormat);

export const Cervicalphysical = ({ data, onChange }) => {
  const assesDate = data?.assesDate || '';
  const polyp = data?.polyp;
  const ectopy = data?.ectopy;
  const hyptrphy = data?.hyptrphy;
  const dischrg = data?.dischrg;
  const proUtrus = data?.proUtrus;
  const bldTouch = data?.bldTouch;
  const unCervx = data?.unCervx;
  const susCervx = data?.susCervx;
  const maligncy = data?.maligncy;
  const othr = data?.othr;
  const othrStr = data?.othrStr || '';

  const crvclLctns = data?.crvclLctns || {
    viaTestResult: '',
    viaPoints: null
  };

  const viaTestResult = crvclLctns.viaTestResult || '';
  const viaPoints = crvclLctns.viaPoints || [];
  const isClickable = viaTestResult === "Positive" || viaTestResult === "Suspicious";

  const getPrefix = (result) => {
    if (result === 'Negative') return 'CNS';
    if (result === 'Positive') return 'CPS';
    if (result === 'Suspicious') return 'CCS';
    return 'CPS'; // default fallback
  };

  const isDotActive = (index) => {
    if (!isClickable) return false;
    const prefix = getPrefix(viaTestResult);
    return viaPoints && viaPoints.includes(`${prefix}${index + 1}`);
  };

  const handleTestResultChange = (newResult) => {
    if (newResult === 'Negative') {
      onChange({
        ...data,
        crvclLctns: {
          viaTestResult: newResult,
          viaPoints: null
        }
      });
      return;
    }

    const newPrefix = getPrefix(newResult);

    const updatedPoints = (viaPoints || []).map(point => {
      const match = point.match(/\d+/);
      return match ? `${newPrefix}${match[0]}` : null;
    }).filter(Boolean);

    onChange({
      ...data,
      crvclLctns: {
        viaTestResult: newResult,
        viaPoints: updatedPoints.length > 0 ? updatedPoints : null
      }
    });
  };

  const togglePoint = (index) => {
    if (!isClickable) return;
    const prefix = getPrefix(viaTestResult);
    const label = `${prefix}${index + 1}`;

    let updatedPoints = viaPoints ? [...viaPoints] : [];
    if (updatedPoints.includes(label)) {
      updatedPoints = updatedPoints.filter(p => p !== label);
    } else {
      updatedPoints.push(label);
    }

    onChange({
      ...data,
      crvclLctns: {
        viaTestResult,
        viaPoints: updatedPoints.length > 0 ? updatedPoints : null
      }
    });
  };

  const handleFieldChange = (name, value) => {
    onChange({
      ...data,
      [name]: value
    });
  };

  return (
    <>
      <Box className="cirvicalCancerSection" sx={{ mb: 3 }}>
        <Box className="date_cont" sx={{ mb: 3, display: 'flex', width: '100%' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Assessment Date"
              format="DD/MM/YYYY"
              value={assesDate ? dayjs(assesDate, 'DD-MM-YYYY') : null}
              onChange={(newValue) => handleFieldChange('assesDate', newValue ? newValue.format('DD-MM-YYYY') : '')}
              maxDate={dayjs()}
              disableFuture
              slotProps={{
                textField: {
                  fullWidth: true,
                  sx: { maxWidth: 300 },
                  error: !!(assesDate && dayjs(assesDate, 'DD-MM-YYYY').isValid() && dayjs(assesDate, 'DD-MM-YYYY').isAfter(dayjs(), 'day')),
                  helperText: assesDate && dayjs(assesDate, 'DD-MM-YYYY').isValid() && dayjs(assesDate, 'DD-MM-YYYY').isAfter(dayjs(), 'day') ? 'Assessment Date cannot be a future date' : ''
                }
              }}
            />
          </LocalizationProvider>
        </Box>

        <div className="VIATesting" style={{ marginBottom: '30px' }}>
          <div className="panel panel-success" style={{ border: '1px solid #d6e9c6', borderRadius: '4px', marginBottom: '15px' }}>
            <div className="panel-heading" style={{ background: '#dff0d8', color: '#3c763d', padding: '10px 15px' }}>
              <FormControlLabel
                value="Negative"
                control={
                  <Radio
                    name="cervicalResult"
                    checked={viaTestResult === "Negative"}
                    onChange={() => handleTestResultChange("Negative")}
                    sx={{
                      color: '#3c763d',
                      '&.Mui-checked': {
                        color: '#3c763d',
                      },
                      p: 0,
                      mr: 1
                    }}
                  />
                }
                label="Negative"
                sx={{
                  m: 0,
                  width: '100%',
                  '& .MuiFormControlLabel-label': {
                    fontWeight: 600,
                    color: '#3c763d'
                  }
                }}
              />
            </div>
            <div className="panel-body" style={{ padding: '15px' }}>
              <p>No aceto-white lesions without definite margins</p>
              <p>Transparent lesions or faint patchy lesions</p>
              <p>Nabothian cysts becoming aceto-white</p>
              <p>Faint line like aceto-whitening at the junction of columnar and squamous epithelium</p>
              <p>Faint aceto-white lesions far away from the transformation zone</p>
            </div>
          </div>

          <div className="panel panel-danger" style={{ border: '1px solid #ebccd1', borderRadius: '4px', marginBottom: '15px' }}>
            <div className="panel-heading" style={{ background: '#f2dede', color: '#a94442', padding: '10px 15px' }}>
              <FormControlLabel
                value="Positive"
                control={
                  <Radio
                    name="cervicalResult"
                    checked={viaTestResult === "Positive"}
                    onChange={() => handleTestResultChange("Positive")}
                    sx={{
                      color: '#a94442',
                      '&.Mui-checked': {
                        color: '#a94442',
                      },
                      p: 0,
                      mr: 1
                    }}
                  />
                }
                label="Positive"
                sx={{
                  m: 0,
                  width: '100%',
                  '& .MuiFormControlLabel-label': {
                    fontWeight: 600,
                    color: '#a94442'
                  }
                }}
              />
            </div>
            <div className="panel-body" style={{ padding: '15px' }}>
              <p>Distinct, opaque aceto-white area</p>
              <p>Margin should be well defined, may or may not be raised</p>
              <p>Abnormality close to the squamo-columnar junction in the transformation zone and not far away from the os</p>
              <p>Entire cervix becomes densely white after the application of acetic acid</p>
              <p>Strikingly dense acetowhite areas are seen in the columnar epithelium</p>
            </div>
          </div>

          <div className="panel panel-warning" style={{ border: '1px solid #faebcc', borderRadius: '4px', marginBottom: '15px' }}>
            <div className="panel-heading" style={{ background: '#fcf8e3', color: '#8a6d3b', padding: '10px 15px' }}>
              <FormControlLabel
                value="Suspicious"
                control={
                  <Radio
                    name="cervicalResult"
                    checked={viaTestResult === "Suspicious"}
                    onChange={() => handleTestResultChange("Suspicious")}
                    sx={{
                      color: '#8a6d3b',
                      '&.Mui-checked': {
                        color: '#8a6d3b',
                      },
                      p: 0,
                      mr: 1
                    }}
                  />
                }
                label="Suspicious of cancer"
                sx={{
                  m: 0,
                  width: '100%',
                  '& .MuiFormControlLabel-label': {
                    fontWeight: 600,
                    color: '#8a6d3b'
                  }
                }}
              />
            </div>
            <div className="panel-body" style={{ padding: '15px' }}>
              <p>Obvious growth or ulcer in the cervix. Aceto-white area may not be visible because of bleeding</p>
            </div>
          </div>
        </div>

        <div className="cirvicalImgSection" style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px', pointerEvents: isClickable ? 'auto' : 'none', opacity: isClickable ? 1 : 0.6 }}>
          <div className="circle-container" style={{ position: 'relative', width: '325px', height: '329px' }}>
            <img src={"/images/cervical_cancer_diagram.png"} style={{ width: '325px', height: '329px' }} alt="Cervical Cancer Diagram" />
            {Array.from({ length: 12 }).map((_, i) => {
              const rotatedIndex = (i + 1) % 12;
              const angle = (360 / 12) * rotatedIndex - 90;
              const radius = 120;
              const x = radius * Math.cos((angle * Math.PI) / 180);
              const y = radius * Math.sin((angle * Math.PI) / 180);
              const active = isDotActive(i);

              return (
                <div
                  key={i}
                  className={`dotCirvical ${active ? "active" : ""}`}
                  style={{
                    transform: `translate(${x}px, ${y}px)`,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    width: '34px',
                    height: '34px',
                    marginTop: '-17px',
                    marginLeft: '-17px',
                  }}
                  onClick={() => togglePoint(i)}
                />
              );
            })}
          </div>
        </div>

        <div className="cirvicalFormSection" style={{ marginTop: '30px' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 3, borderBottom: '1px solid #e0e0e0', pb: 1 }}>
            Per speculum examination:
          </Typography>

          <Box className="row" sx={{ mb: 2 }}>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Polyp:</FormLabel>
                <RadioGroup
                  name="polyp"
                  value={polyp === null ? "" : String(polyp)}
                  onChange={(e) => handleFieldChange('polyp', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Ectopy (Erosion):</FormLabel>
                <RadioGroup
                  name="ectopy"
                  value={ectopy === null ? "" : String(ectopy)}
                  onChange={(e) => handleFieldChange('ectopy', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Hypertrophy:</FormLabel>
                <RadioGroup
                  name="hyptrphy"
                  value={hyptrphy === null ? "" : String(hyptrphy)}
                  onChange={(e) => handleFieldChange('hyptrphy', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>

          <Box className="row" sx={{ mb: 2 }}>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Excessive Discharge:</FormLabel>
                <RadioGroup
                  name="dischrg"
                  value={dischrg === null ? "" : String(dischrg)}
                  onChange={(e) => handleFieldChange('dischrg', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Prolapse Uterus:</FormLabel>
                <RadioGroup
                  name="proUtrus"
                  value={proUtrus === null ? "" : String(proUtrus)}
                  onChange={(e) => handleFieldChange('proUtrus', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Bleeds on Touch:</FormLabel>
                <RadioGroup
                  name="bldTouch"
                  value={bldTouch === null ? "" : String(bldTouch)}
                  onChange={(e) => handleFieldChange('bldTouch', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>

          <Box className="row" sx={{ mb: 2 }}>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Unhealthy Cervix:</FormLabel>
                <RadioGroup
                  name="unCervx"
                  value={unCervx === null ? "" : String(unCervx)}
                  onChange={(e) => handleFieldChange('unCervx', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Suspicious looking Cervix:</FormLabel>
                <RadioGroup
                  name="susCervx"
                  value={susCervx === null ? "" : String(susCervx)}
                  onChange={(e) => handleFieldChange('susCervx', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Frank Malignancy or Growth on the Cervix:</FormLabel>
                <RadioGroup
                  name="maligncy"
                  value={maligncy === null ? "" : String(maligncy)}
                  onChange={(e) => handleFieldChange('maligncy', e.target.value === "true")}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>

          <Box className="row" sx={{ mb: 2 }}>
            <Box className="col-md-4 col-xs-12" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: 600, color: '#333', mb: 1 }}>Others:</FormLabel>
                <RadioGroup
                  name="othr"
                  value={othr === null ? "" : String(othr)}
                  onChange={(e) => {
                    const isOther = e.target.value === "true";
                    onChange({
                      ...data,
                      othr: isOther,
                      othrStr: isOther ? othrStr : ''
                    });
                  }}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            {othr && (
              <Box className="col-md-8 col-xs-12" sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  name="othrStr"
                  label="Please specify other findings"
                  value={othrStr}
                  onChange={(e) => handleFieldChange('othrStr', e.target.value)}
                />
              </Box>
            )}
          </Box>
        </div>
      </Box>
    </>
  );
};
